<template>
  <v-card style="height: 100%">
    <div class="mobile-max-300w d-chart-card" style="height: 100%">
      <v-row
        no-gutters
        class="mx-2 mt-0 mb-1"
        style="min-width: 500px !important"
      >
        <p
          v-if="cardInfo.name"
          :key="chartNameRenderKey"
          class="mb-2 mt-4 ml-3 chartTitle"
        >
          {{ cardInfo.name }} - {{ cardSymbol }}
        </p>
        <v-spacer></v-spacer>

        <!-- Show the zoom button if initial loading is done & some data is rendered -->
        <v-btn
          v-if="showZoomButton"
          @click="changeZoomSetting"
          icon
          small
          class="absolute"
          style="right: 115px; top: 72px; z-index: 1"
        >
          <div v-if="leveledZoom">
            <v-img
              max-height="16"
              max-width="16"
              src="../../assets/views-images/pricewatcher/zoom.png"
              x-small
            ></v-img>
          </div>
          <v-img
            v-else-if="horizontalZoom && verticalZoom"
            max-height="16"
            max-width="16"
            src="../../assets/views-images/pricewatcher/zoom_percise.png"
            x-small
          ></v-img>
          <!-- <div v-if="horizontalZoom && !verticalZoom">
            <v-img
              v-if="$vuetify.theme.dark"
              max-height="16"
              max-width="16"
              src="../../assets/views-images/pricewatcher/zoom_x_dark.png"
              x-small
            ></v-img>
            <v-img
              v-else
              max-height="16"
              max-width="16"
              src="../../assets/views-images/pricewatcher/zoom_x_light.png"
              x-small
            ></v-img>
          </div>
          <div v-else-if="verticalZoom && !horizontalZoom">
            <v-img
              v-if="$vuetify.theme.dark"
              max-height="16"
              max-width="16"
              src="../../assets/views-images/pricewatcher/zoom_y_dark.png"
              x-small
            ></v-img>
            <v-img
              v-else
              max-height="16"
              max-width="16"
              src="../../assets/views-images/pricewatcher/zoom_y_light.png"
              x-small
            ></v-img>
          </div> -->
        </v-btn>
        <v-tooltip
          v-if="
            this.historyOption === 0 &&
            tooLongSinceLastPriceUpdate &&
            timeOverdueWatchers
          "
          :disabled="isNotDesktop"
          class="absolute"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div
              @click="this.$router.push('/settings')"
              v-on="on"
              class="mr-3 mt-4"
              style="position: relative"
            >
              <v-icon
                small
                color="red"
                class="mt-1"
                style="font-size: 12px; margin-right: 2px"
                >fas fa-exclamation</v-icon
              >
              <v-icon small color="red" class="mt-1" style="font-size: 12px"
                >fas fa-clock</v-icon
              >
            </div>
          </template>
          <span
            >Haven't received any data in a while from watcher(s):<br />
            {{ timeOverdueWatchers }}
          </span>
        </v-tooltip>
        <p class="mb-0 mr-1" style="font-size: 0.8125rem; padding-top: 21px">
          Step:
        </p>
        <div style="width: 30px !important">
          <v-select
            dense
            class="hide-spin-buttons chart-stepper-selector mt-1"
            hide-details
            hide-spin-buttons
            :menu-props="{ bottom: true, offsetY: true }"
            height="40px"
            :items="stepperOptions"
            item-text="text"
            item-value="value"
            v-model="stepper"
            @change="stepperChanged"
          >
            <template v-slot:item="{ item }">
              <div class="mb-0 char-lim-tabs page-rows-selection">
                <div>{{ item.text }}</div>
              </div>
            </template>
            <template v-slot:selection="{ item }">
              <div class="page-rows-selection">
                <div class="primary--text">
                  {{ item.text }}
                </div>
              </div>
            </template>
          </v-select>
        </div>
        <v-item-group
          v-model="historyOption"
          mandatory
          class="px-2 mt-2 watcher-card-option-divider"
          :style="
            $vuetify.theme.dark ? 'background: #262b2e' : 'background: #edeef2'
          "
          style="
            border-radius: 4px !important;
            border-right-radius: 0 !important;
          "
        >
          <v-container class="py-2">
            <v-row>
              <div v-for="(option, i) in historyOptions" :key="option">
                <v-item v-slot="{ active, toggle }">
                  <v-card
                    :color="active ? '#1C6E59' : 'accent'"
                    :class="{
                      selectedHistoryOption: selectedHistoryOption === option,
                      'active-card': active,
                    }"
                    class="d-flex align-center watcher-history-option"
                    elevation="0"
                    height="30"
                    width="32"
                    @click="
                      changeChartHistoryOption(option);
                      toggle();
                    "
                  >
                    <v-scroll-y-transition>
                      <v-tooltip
                        v-if="i === 0"
                        :disabled="isNotDesktop"
                        class="mt-3 ml-1"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" x-small style="margin-left: 9px"
                            >fas fa-broadcast-tower</v-icon
                          >
                          <div
                            v-show="historyOption === 0"
                            v-on="on"
                            class="live_data_icon"
                          >
                            <div class="circle--outer"></div>
                            <div class="circle--inner"></div>
                          </div>
                        </template>
                        <span>Live</span>
                      </v-tooltip>
                      <div
                        v-else
                        class="flex-grow-1 text-center history-option"
                        style="font-size: 12px !important"
                      >
                        {{ option }}
                      </div>
                    </v-scroll-y-transition>
                  </v-card>
                </v-item>
              </div>
            </v-row>
          </v-container>
        </v-item-group>
        <!-- <hr
              width="0"
              color="transparent"
              style="height:20px; border-left:1px solid red;"
            /> -->
        <div
          :style="
            $vuetify.theme.dark ? 'background: #262b2e' : 'background: #edeef2'
          "
          class="mt-2 pr-3"
          style="height: 46px; border-radius: 0; padding-left: 20px"
        >
          <v-row>
            <div class="py-2">
              <v-tooltip :disabled="isNotDesktop" class="mt-3 ml-1" bottom>
                <template v-slot:activator="{ on }">
                  <v-card
                    @click="deleteChart"
                    v-on="on"
                    elevation="0"
                    height="30"
                    width="32"
                    color="accent"
                    :class="
                      selectedHistoryOption === 'delete'
                        ? 'selectedHistoryOption'
                        : ''
                    "
                    class="d-flex align-center watcher-history-option"
                  >
                    <v-icon
                      class="flex-grow-1 text-center"
                      style="font-size: 12px !important"
                    >
                      fa-solid fa-trash
                    </v-icon>
                  </v-card>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </div>
            <div class="py-2">
              <v-tooltip :disabled="isNotDesktop" class="mt-3 ml-1" bottom>
                <template v-slot:activator="{ on }">
                  <v-card
                    @click="editChart"
                    v-on="on"
                    elevation="0"
                    height="30"
                    width="32"
                    color="accent"
                    :class="
                      selectedHistoryOption === 'delete'
                        ? 'selectedHistoryOption'
                        : ''
                    "
                    class="d-flex align-center watcher-history-option"
                  >
                    <span
                      :class="
                        $vuetify.theme.dark ? 'ec-darkEdit' : 'ec-lightEdit'
                      "
                      style="
                        font-size: 27px;
                        margin-bottom: 2px;
                        margin-left: 28px;
                      "
                      class="icon-edit-21x21"
                    >
                      <span class="path2"></span>
                    </span>
                  </v-card>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </div>
            <div class="py-2 pr-1">
              <v-tooltip :disabled="isNotDesktop" class="mt-3 ml-1" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="$emit('draggable-switch')"
                    v-on="on"
                    icon
                    small
                  >
                    <v-icon
                      :color="draggable ? 'primary' : 'white'"
                      class="dragFromHere"
                      small
                      >fas fa-arrows-alt</v-icon
                    >
                  </v-btn>
                </template>
                <span>Drag & Resize : {{ draggable ? "ON" : "OFF" }}</span>
              </v-tooltip>
            </div>
          </v-row>
        </div>
      </v-row>
      <loading-page
        v-if="initialLoading || !settingsLoaded"
        style="margin-top: -54px"
      ></loading-page>
      <div
        v-else-if="chartError"
        style="height: calc(100% - 62px); width: 100%"
      >
        <v-container class="loading" style="height: 100%" fluid>
          <v-row style="height: 100%" align="center" justify="center">
            <v-icon large color="grey" class="mr-2 mb-1" small
              >fas fa-exclamation-triangle</v-icon
            >
            <p class="mb-0 grey--text">
              There was a problem displaying this chart
            </p>
          </v-row>
        </v-container>
      </div>
      <div
        v-else-if="chartIsEmpty && !loadingChartsData"
        style="height: calc(100% - 62px); width: 100%"
      >
        <v-container class="loading" style="height: 100%" fluid>
          <v-row style="height: 100%" align="center" justify="center">
            <v-icon large color="grey" class="mr-2 mb-1" small
              >fas fa-exclamation-triangle</v-icon
            >
            <p class="mb-0 grey--text">No data available</p>
          </v-row>
        </v-container>
      </div>
      <div
        v-else
        class="chart-wrapper"
        style="min-width: 500px !important; height: calc(100% - 62px)"
      >
        <v-chart
          :ref="`chart-${cardInfo.id}`"
          @rendered="chartRendered"
          :class="`chart chart-${cardInfo.id} px-4 py-0`"
          :update-options="updateOptions"
          :option="chartOption"
          :loading="(loadingChartsData || chartIsEmpty) && !initialLoading"
          :loading-options="{
            text: 'Loading...',
            color: '#47BD96',
            textColor: 'grey',
            maskColor: 'transparent',
            fontFamily: 'Roboto',
          }"
          :autoresize="true"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, LineChart, CandlestickChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { LoadingPage } from "../../components/Default-Page-Components";
import { QueryService } from "@/services/ApiService";
import {
  defaultChartOption,
  defaultChartSeries,
  defaultChartZoom
} from "@/utilities/DefaultObjects";
// import { getTooltipTemplate } from "../../utilities/pricewatcher-helpers";
import { events } from "@/plugins/events";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  LineChart,
  CandlestickChart,
]);

let stepperTimer = null;

export default {
  name: "ChartCard",
  components: {
    VChart,
    LoadingPage,
  },
  data: () => ({
    tooLongSinceLastPriceUpdate: false,
    timeOverdueWatchers: "",
    leveledZoom: true,
    verticalZoom: false,
    horizontalZoom: false,
    currentTime: 0,
    PWSettingsLoaded: false,
    PWSettings: null,
    initialLoading: true,
    chartIsEmpty: false,
    chartError: false,
    historyOption: 1,
    loadingChartsData: true,
    chartNameRenderKey: 0,
    updateOptions: { notMerge: false },
    historyOptions: ["LIVE", "1D", "7D", "1M", "ALL"],
    chartOption: null,
    stepper: 3600,
    stepperOptions: [
      { text: "1S", value: 1 },
      { text: "5S", value: 5 },
      { text: "10S", value: 10 },
      { text: "15S", value: 15 },
      { text: "30S", value: 30 },
      { text: "1M", value: 60 },
      { text: "5M", value: 300 },
      { text: "10M", value: 600 },
      { text: "15M", value: 900 },
      { text: "30M", value: 1800 },
      { text: "1H", value: 3600 },
      { text: "3H", value: 10800 },
      { text: "4H", value: 14400 },
      { text: "1D", value: 86400 },
    ],
    // dataZoomX: {
    //   id: "dataZoomX",
    //   disabled: false,
    //   type: "inside",
    //   xAxisIndex: [0],
    //   minSpan: 0.7,
    //   filterMode: "none",
    //   showDetail: false,
    // },
    // dataZoomY: {
    //   id: "dataZoomY",
    //   disabled: false,
    //   type: "inside",
    //   minSpan: 0.7,
    //   yAxisIndex: [0],
    //   filterMode: "none",
    //   showDetail: false,
    // },
  }),
  props: {
    selectedHistoryOption: {
      type: String,
      default: "",
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    cardInfo: {
      type: Object,
      default: () => {},
    },
    cardSymbol: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 1,
    },
    height: {
      type: Number,
      default: 1,
    },
    definitions: {
      type: Array,
      default: () => [],
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isPublic: {
      type: Boolean,
      default: false
    },
    connectionLost: {
      type: Boolean,
      default: false,
    },
    settingsLoaded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // convertEpochToSpecificTimezone(timeEpoch) {
    //   var d = new Date(timeEpoch);
    //   var utc = d.getTime() + d.getTimezoneOffset() * 60000; //This converts to UTC 00:00
    //   var nd = new Date(utc + 3600000);
    //   return nd.toLocaleString();
    // },
    changeHorizontalAndVerticalZoom({ horizontal, vertical, leveled }) {
      if (leveled === true) {
        // this.chartOption.dataZoom = this.jsonParse(dataZooms);
        let chartOption = this.jsonParse(this.chartOption);
        chartOption.dataZoom = [
          {
            type: "inside",
            throttle: 50,
          },
        ];
        this.chartOption = chartOption;
        this.sizeChartToFit(this.cardInfo.id, this.width, this.height);

        this.leveledZoom = true;
        this.horizontalZoom = false;
        this.verticalZoom = false;

        return;
      } else {
        this.leveledZoom = false;
      }
      let dataZooms;
      if (this.chartOption.dataZoom && this.chartOption.dataZoom.length > 1) {
        dataZooms = this.jsonParse(this.chartOption.dataZoom);
      } else {
        dataZooms = this.jsonParse(defaultChartZoom);
      }
      if (horizontal) {
        dataZooms[0].disabled = false;
        this.horizontalZoom = true;
      } else {
        dataZooms[0].disabled = true;
        this.horizontalZoom = false;
      }
      if (vertical) {
        dataZooms[1].disabled = false;
        this.verticalZoom = true;
      } else {
        dataZooms[1].disabled = true;
        this.verticalZoom = false;
      }

      // if (vertical && !horizontal && !leveled) {
      //   dataZooms = [
      //     {
      //       id: "dataZoomY",
      //       disabled: false,
      //       type: "inside",
      //       minSpan: 0.7,
      //       yAxisIndex: [0],
      //       filterMode: "none",
      //       showDetail: false,
      //     },
      //   ];
      // }

      if (this.$refs[`chart-${this.cardInfo.id}`]) {
        this.chartOption.dataZoom = this.jsonParse(dataZooms);
        // let chartOption = this.jsonParse(this.chartOption);
        // chartOption.dataZoom = this.jsonParse(dataZooms);
        // this.chartOption = chartOption;
        // this.sizeChartToFit(this.cardInfo.id, this.width, this.height);
      }
    },
    changeZoomSetting() {
      let zooms = { horizontal: false, vertical: false, leveled: false };

      if (this.leveledZoom) {
        zooms.leveled = false;
        zooms.horizontal = true;
        zooms.vertical = true;
      } else {
        zooms.leveled = true;
        zooms.horizontal = false;
        zooms.vertical = false;
      }
      // if (this.leveledZoom) {
        //   zooms.leveled = false;
      //   zooms.horizontal = true;
      //   zooms.vertical = true;
      // } else if (this.horizontalZoom && this.verticalZoom) {
        //   zooms.vertical = false;
      //   zooms.horizontal = true;
      // } else if (this.horizontalZoom && !this.verticalZoom) {
        //   zooms.horizontal = false;
      //   zooms.vertical = true;
      // } else if (!this.horizontalZoom && this.verticalZoom) {
        //   zooms.horizontal = false;
      //   zooms.vertical = false;
      //   zooms.leveled = true;
      // }
      this.changeHorizontalAndVerticalZoom(zooms);
      this.restoreChart(this.cardInfo.id)
    },
    jsonParse(v) {
      if (v === undefined) return [];
      return JSON.parse(JSON.stringify(v));
    },
    duplicateLastDataPoint(series) {
      let lastPoint = series.lastUpdate && series.lastValueReceived ? [series.lastUpdate, series.lastValueReceived] : series.data[series.data.length - 1]

      // if(series.lastValueReceived)
      // else lastPoint = series.data[series.data.length - 1];

      let stepperTimesTwo = this.stepper * 2 * 1000;

      /*
        If the time between the last points' timeStamp & currentTime is bigger than 2 "steps"
        Then use currentTime as the timeStamp for the new point
        Otherwise use "last points' timestamp" + step as timeStamp
      */
      let timeStamp =
        this.currentTime - lastPoint[0] > stepperTimesTwo
          ? this.currentTime
          : lastPoint[0] + this.stepper * 1000;

      let newPoint = [timeStamp, lastPoint[1]];

      series.data.push(newPoint);
    },
    // DESCRIPTION: 
    // Check if any data was received during the las N seconds.
    // N being the "stepper" set by the user
    noDataInLastTimeInterval(series) {
      // noDataInLastTimeInterval means that a time of "step" selected has passed and no new data was received
      let interval = this.stepper * 1000;

      let noData = false;
      if (series.data.length) {
        let lastPointTimestamp = series.data[series.data.length - 1][0];
        this.currentTime = Date.now();
        if (lastPointTimestamp + interval < this.currentTime) {
          noData = true;
        }
      }

      return noData;
    },
    setStepperTimer() {
      clearInterval(stepperTimer);

      stepperTimer = setInterval(() => {
        let keepPreviousTimeFrameData = false;
        if (this.PWSettings && this.PWSettings.keepPreviousTimeFrameData) {
          keepPreviousTimeFrameData = true;
        }

        // DESCRIPTION: 
        // 1. keepPreviousTimeFrameData is a variable set by user which indicates
        // wether the chart should automatically add new points if no data was received in a while
        // 2. this.historyOption != 0 means that the chart is not in "LIVE" mode
        // 3. this.connectionLost (sse) connection with the server was lost
        if (
          !keepPreviousTimeFrameData ||
          this.historyOption !== 0 ||
          this.connectionLost
        ) {
          return;
        }

        let tooLongSinceLastPriceUpdate = false;
        let timeOverdueWatchers = "";
        let timeNow = Date.now();

        this.chartOption.series.forEach((series) => {
          if (series.lastUpdate) {
            let dataAbsenceTimeLimit =
              this.PWSettings && this.PWSettings.dataAbsenceWarning
                ? this.PWSettings.dataAbsenceWarning * 1000
                : 120000;
            if (timeNow - series.lastUpdate > dataAbsenceTimeLimit) {
              if (timeOverdueWatchers.length)
                timeOverdueWatchers += `, ${series.name}`;
              else {
                tooLongSinceLastPriceUpdate = true;
                timeOverdueWatchers = series.name;
              }
              // timeOverdueWatchers.push(series.name)
            }
          }

          if (this.noDataInLastTimeInterval(series)) {
            this.duplicateLastDataPoint(series);
          }
        });

        // DESCRIPTION:
        // tooLongSinceLastPriceUpdate is used to show the data absence indicator
        // timeOverdueWatchers is a string with the watchers that hava absent data
        this.tooLongSinceLastPriceUpdate = tooLongSinceLastPriceUpdate;
        this.timeOverdueWatchers = timeOverdueWatchers;
      }, this.stepper * 1000 + 1000);
    },
    chartRendered() {
      if (this.updateOptions.notMerge) this.updateOptions.notMerge = false;
    },
    getIdentity(applicationCode, id) {
      let identity = applicationCode;
      if (id < 10) {
        identity = identity + "00" + id;
      } else if (id < 100) {
        identity = identity + "0" + id;
      } else {
        identity = identity + id;
      }
      return identity;
    },
    priceUpdate(payload) {
      if (
        !this.chartOption ||
        (typeof this.chartOption == "object" &&
          this.chartOption.hasOwnProperty("series") &&
          !this.chartOption.series.length)
      ) {
        return; // return to avoid any errors
      }

      // If this.stepper ammount of time has passed since the timestamp on the last point on the chart (for that specific watcher)
      // push the new value into the series

      let series = this.chartOption.series.find(
        (el) => el.identity === payload.identity
      );

      if (!series) {
        return;
      }
      // DESCRIPTION:
      // Remove this watcher from the list of data absent watchers
      if (this.timeOverdueWatchers.includes(series.name)) {
        // If this watcher is the last in the list of absent data watchers then remove it and hide the warning
        if(!this.timeOverdueWatchers.includes(',')) {
          this.tooLongSinceLastPriceUpdate = false;
          this.timeOverdueWatchers = "";
        } else {
          this.timeOverdueWatchers.replace(`, ${series.name}`, "");
          this.timeOverdueWatchers.replace(series.name, "");
        }
      }

      let lastPointTime = series.data[series.data.length - 1][0];

      if (payload.update.datetime > lastPointTime + this.stepper * 1000) {
        series.data.push([payload.update.datetime, payload.update.points]);
      }
      series.lastUpdate = Date.now();
      series.lastValueReceived = payload.update.points
    },
    changeChartHistoryOption(option) {
      this.$emit("change-history-option", option);
    },
    getParams() {
      return {
        symbol: this.cardInfo.symbols,
        type: "CHART",
        watchers: this.cardInfo.watchers,
        timeSpan: this.stepper,
        // watchers: chart.properties.watchers.map(el => "PW" + el),
      };
    },
    refreshChart() {
      this.loadingChartsData = true;

      let params = this.getParams();

      QueryService.Chart.post(params)
        .then((response) => {
          this.chartError = false;
          this.setChartOption(this.cardInfo, response.data);
          this.loadingChartsData = false;
        })
        .catch((error) => {
          this.chartError = true;
          this.$notifier.error(
            "Oops! Something went wrong when fetching charts data."
          );
          console.error(error);
          this.loadingChartsData = false;
        });
    },
    stepperChanged() {
      this.refreshChart();
      this.$emit("stepper-changed", this.stepper);
    },
    // tooltipFormatter(args) {
    //   // var minMaxValues = data.minMaxValues[args[0].dataIndex];
    //   // let template = getTooltipTemplate(args, minMaxValues);
    //   return getTooltipTemplate(args);
    // },
    getWatchersNamesAndIds(watcherIds) {
      let names = [];
      watcherIds.forEach((watcherId) => {
        let definition = this.definitions.find((el) => {
          let identity = this.getIdentity(el.application.code, el.id);

          return identity === watcherId;
        });

        if (definition)
          names.push({
            name: definition.name,
            id: this.getIdentity(definition.application.code, definition.id),
          });
      });
      return names;
    },
    setChartOption(chart, data) {
      let option = JSON.parse(JSON.stringify(defaultChartOption));

      // Set Legend data (line names)
      let chartWatchers = this.getWatchersNamesAndIds(chart.watchers);

      // Create data series objects
      let seriesArray = [];
      chartWatchers.forEach((watcher) => {
        if (!data[watcher.id]) {
          return;
        }
        let series = JSON.parse(JSON.stringify(defaultChartSeries));
        series.name = watcher.name;
        series.identity = watcher.id;
        series.lastUpdate = Date.now();
        // series.data = [
        //   [1658066635, 4],
        //   [1658067635, 5],
        //   [1658068635, 3],
        // ];

        series.data = data[watcher.id];

        option.legend.data.push(watcher.name);
        seriesArray.push(series);
      });

      option.series = seriesArray;
      // TODO Uncomment the following line for "History mode"
      // option.tooltip.formatter = this.tooltipFormatter;

      if (option.series.length) {
        this.chartIsEmpty = false;
      } else this.chartIsEmpty = true;

      this.updateOptions.notMerge = true;
      this.chartOption = option;

      // this.$nextTick(() => {
      //   this.updateOptions.notMerge = false
      // })
    },
    fetchChartData() {
      this.loadingChartsData = true;
      let params = this.getParams();
      QueryService.Chart.post(params)
        .then((response) => {
          this.chartError = false;
          this.setChartOption(this.cardInfo, response.data);
          this.loadingChartsData = false;
          if (this.initialLoading) {
            this.initialLoading = false;
            // TODO: make there is no need to resize the chart here then remove the folliwng:
            // this.sizeChartToFit(this.cardInfo.id, this.width, this.height);
          }
          this.setStepperTimer();
        })
        .catch((error) => {
          this.chartError = true;
          this.loadingChartsData = false;
          this.initialLoading = false;
          this.$notifier.error(
            "Oops! Something went wrong when fetching charts data."
          );
          console.error(error);
        });
    },
    rerenderChartName() {
      if (this.chartNameRenderKey > 10) this.chartNameRenderKey = 0;
      else this.chartNameRenderKey++;
    },
    deleteChart() {
      this.$emit("delete", this.cardInfo);
    },
    editChart() {
      this.$emit("edit", this.cardInfo.id);
    },
    sizeChartToFit(id, width, height) {
      if (this.$refs[`chart-${id}`]) {
        this.$refs[`chart-${id}`].resize({
          height: height * 65,
        });
      }
    },
    restoreChart(id) {
      if (this.$refs[`chart-${id}`]) {
        this.$refs[`chart-${id}`].dispatchAction({
          type: "restore",
        });
      }
    },
  },
  computed: {
    showZoomButton() {
      return (
        this.settingsLoaded &&
        !this.initialLoading &&
        !(this.chartIsEmpty && !this.loadingChartsData) &&
        !this.chartError
      );
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
    getChartSymbol() {
      return this.cardInfo.symbols;
    },
    ...mapGetters(["getSpecificSetting"]),
  },
  created() {
    // Set stepper (saved in page state)
    if (this.cardInfo.stepper) this.stepper = this.cardInfo.stepper;
    // Set history option (saved in page state)
    if (this.cardInfo.historyOption) {
      let index = this.historyOptions.indexOf(this.cardInfo.historyOption);
      if (index !== -1) this.historyOption = index;
    }

    this.fetchChartData();
  },
  mounted() {
    if (this.settingsLoaded && !this.PWSettingsLoaded) {
      this.PWSettings = this.getSpecificSetting({
        section: "applications",
        innerSection: "pricewatcher",
      });
      this.PWSettingsLoaded = true;
    }

    this.sizeChartToFit(this.cardInfo.id, this.width, this.height);

    // TODO
    // Issue to fix:
    // When a new data comes before you coulnt just emit "this.cardInfo.symbol-update" event
    // and all charts with that symbol would be updated.
    // Now you will need to create an array of charts to update (each chart must have have that same symbol and watcher)
    // and update all those charts by $refs.

    // Another solution is to find a way to change the name of the events.$on

    events.$on(`chart-${this.cardInfo.id}-update`, (payload) => {
      if (payload.type === "PRICE_UPDATE" && !this.loadingChartsData) {
        this.priceUpdate(payload);
      } else if (payload.type === "CARD_UPDATE") {
        this.tooLongSinceLastPriceUpdate = false;
        this.timeOverdueWatchers = "";
        this.fetchChartData();
      }
    });

    // TODO
    //  Calculate & set the initial height of the chart
    // let className = `chart-${this.cardInfo.id}`
    // let className = `chart`
    // let chartElement = document.getElementsByClassName(className)
    // chartElement[0].style.height = "800px"
  },
  beforeDestroy() {
    events.$off(`chart-${this.cardInfo.id}-update`);
  },
  watch: {
    /*
      // TODO before removing the following code/comments
      // Make sure to find a way to resize the chart when a step has been changed
      // because if the chart wasnt rendered yet then it will render with the height of 200px (default height)

      loadingChartsData(value) {
        // Avoid showing the chart with default 200px height
        if(value && (this.chartIsEmpty || this.chartError))
          this.sizeChartToFit(this.cardInfo.id, this.width, this.height);
      },
    */
    //  leveledZoom
    // leveledZoom(value) {
    //   if (value) {
    //     this.chartOption.dataZoom = [
    //       {
    //         type: "inside",
    //         throttle: 50,
    //       },
    //     ];
    //   }
    // },
    // verticalZoom(value) {
    //   let dataZooms;
    //   if (this.chartOption.dataZoom && this.chartOption.dataZoom.length > 1)
    //     dataZooms = this.jsonParse(this.chartOption.dataZoom);
    //   else
    //     dataZooms = [
    //       {
    //         id: "dataZoomX",
    //         disabled: false,
    //         type: "inside",
    //         xAxisIndex: [0],
    //         minSpan: 0.7,
    //         filterMode: "none",
    //         showDetail: false,
    //       },
    //       {
    //         id: "dataZoomY",
    //         disabled: false,
    //         type: "inside",
    //         minSpan: 0.7,
    //         yAxisIndex: [0],
    //         filterMode: "none",
    //         showDetail: false,
    //       },
    //     ];

    //   dataZooms = dataZooms.map((el) => {
    //     if (el.id == "dataZoomY") el.disabled = !value;
    //     return el;
    //   });

    //   if (this.$refs[`chart-${this.cardInfo.id}`]) {
    //     this.chartOption.dataZoom = this.jsonParse(dataZooms);
    //   }
    // },
    // horizontalZoom(value) {
    //   let dataZooms;
    //   if (this.chartOption.dataZoom && this.chartOption.dataZoom.length > 1) {
    //     dataZooms = this.jsonParse(this.chartOption.dataZoom);
    //   } else {
    //     dataZooms = [
    //       {
    //         id: "dataZoomX",
    //         disabled: false,
    //         type: "inside",
    //         xAxisIndex: [0],
    //         minSpan: 0.7,
    //         filterMode: "none",
    //         showDetail: false,
    //       },
    //       {
    //         id: "dataZoomY",
    //         disabled: false,
    //         type: "inside",
    //         minSpan: 0.7,
    //         yAxisIndex: [0],
    //         filterMode: "none",
    //         showDetail: false,
    //       },
    //     ];
    //   }

    //   dataZooms = dataZooms.map((el) => {
    //     if (el.id == "dataZoomX") el.disabled = !value;
    //     return el;
    //   });

    //   if (this.$refs[`chart-${this.cardInfo.id}`]) {
    //     this.chartOption.dataZoom = this.jsonParse(dataZooms);
    //   }
    // },
    isDark(v) {
      if (!this.$vuetify.theme.dark) {
        this.chartOption.yAxis.splitLine.lineStyle.color = "rgb(0,0,0,0.12)";
        this.chartOption.yAxis.axisLabel.color = "#000";
        this.chartOption.xAxis.axisLabel.color = "#000";
        this.chartOption.legend.textStyle.color = "#000";
      } else {
        this.chartOption.yAxis.splitLine.lineStyle.color =
          "rgba(255, 255, 255, 0.12)";
        this.chartOption.yAxis.axisLabel.color = "#fff";
        this.chartOption.xAxis.axisLabel.color = "#fff";
        this.chartOption.legend.textStyle.color = "#fff";
      }
    },
    settingsLoaded(v) {
      if (v && !this.PWSettingsLoaded) {
        this.PWSettings = this.getSpecificSetting({
          section: "applications",
          innerSection: "pricewatcher",
        });
        this.PWSettingsLoaded = true;
      }
    },
  },
};
</script>
<style scoped></style>
<style>
.chart {
  min-height: 200px;
}
.ec-lightEdit .path2:before {
  color: rgba(0, 0, 0, 0.54) !important;
}
.chartTitle {
  font-size: 1.2rem;
  /* font-size: 0.9rem !important; */
  font-weight: 600;
}
@media (max-width: 700px) {
  .chartTitle {
    font-size: 0.9rem !important;
  }
  .mobile-max-300w {
    max-width: calc(100% - 20px) !important;
    overflow-x: auto !important;
    margin-left: 10px;
    margin-right: 10px;
  }
}

.chart-stepper-selector .v-select__slot {
  margin-bottom: -14px;
}
.chart-stepper-selector .v-input__slot::before {
  display: none !important;
}
.chart-stepper-selector .v-input__slot::after {
  display: none !important;
}
.watcher-history-option {
  border-radius: 8px !important;
}
.watcher-history-option div {
  width: 30px;
}
.watcher-card-option-divider {
  position: relative;
  background: #262b2e;
}

.watcher-card-option-divider:after {
  content: "";
  height: 30%;
  width: 1px;

  position: absolute;
  right: 0;
  top: 15px;

  background-color: #8e8e8e;
}
</style>
